import {SubscriptionPlanTable} from '@gaia/components/SubscriptionPlanTable';
import Close from '@mui/icons-material/Close';
import {Box, IconButton, Modal, Typography} from '@mui/material';

import classes from './GoPremiumModal.module.css';
import {useGoPremiumModalClose, useGoPremiumModalState} from './store';

export function GoPremiumModal() {
    const isOpen = useGoPremiumModalState();
    const onClose = useGoPremiumModalClose();
    const {container, wrapper, content} = classes;

    return (
        <Modal open={isOpen} onClose={onClose}>
            <Box className={container}>
                <Box className={wrapper}>
                    <Header />
                    <Box className={content}>
                        <SubscriptionPlanTable location={'go-premium-modal'} />
                    </Box>
                </Box>
            </Box>
        </Modal>
    );
}

function Header() {
    const onClose = useGoPremiumModalClose();
    const {header, headerText, closeButton, closeIcon} = classes;

    return (
        <Box component='header' className={header}>
            <div className={headerText}>
                <Typography variant='h1'>Get more out of Gaia GPS</Typography>
                <Typography variant='body1'>
                    Get basic maps and planning tools for free or upgrade to unlock the full map
                    catalog and all premium features.
                </Typography>
            </div>

            <IconButton size='medium' className={closeButton} onClick={onClose}>
                <Close className={closeIcon} />
            </IconButton>
        </Box>
    );
}
